import { B2cProductPayload, Product } from "@/generated/graphql/b2c";

export class Cache {
    protected entities = new Map<string, unknown>();

    constructor() {

    }

    getProduct(id: string) {
        return this.entities.get(id) as B2cProductPayload ?? null as null;
    }

    setProduct(product: B2cProductPayload) {
        this.entities.set(product.id, product);
    }

    delete(id: string) {
        this.entities.delete(id);
    }

    clear() {
        this.entities.clear();
    }
}